import { render, staticRenderFns } from "./ProductConfiguration.vue?vue&type=template&id=03abf3c9&scoped=true"
import script from "./ProductConfiguration.vue?vue&type=script&lang=ts"
export * from "./ProductConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./ProductConfiguration.vue?vue&type=style&index=0&id=03abf3c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03abf3c9",
  null
  
)

export default component.exports